import React, { useState } from "react";
import prodVuoto from "../prodottoVuoto";
import apiUrl from "../Apiurl";
import stilePulsanti from "../interfaccia/stilePulsanti";

function InputNomeProd(props) {
    const listaNomiProdotto = props.listaNomiProdotto;
    const setProductFunction = props.setProductFunction;
    const onSearchResults = props.onSearchResults;
    const [input, setInput] = useState("");
    
    const showLabels = props.showLabels;
    const showDescs = props.showDescs;
    const orientamento = props.orientamento;
    let inputStyle;

    const listaNomiProdottoFiltrata = listaNomiProdotto.filter(nome => (typeof nome === 'string' || nome instanceof String) && nome.includes(input.toUpperCase()));
    //console.log('listaNomiProdottoFiltrata con'+input,listaNomiProdottoFiltrata)

    if (orientamento === "verticale") {
      inputStyle = "pr4 pl4 black-80"
    } else if (orientamento === "orizzontale") {
      inputStyle = "pr4 pl4 black-80 flex"
    } else if (orientamento === "tasto") {
      inputStyle = "black-80 flex measure"
    }

    const handleSubmit= (e) => {
        e.preventDefault()
        const shortName = input;
        console.log(shortName);
        fetch(apiUrl+"/prodotti/show/shortname/"+shortName)
        .then(resp => resp.json())
        .then(data => {
          if (typeof onSearchResults === "function") {
            onSearchResults(data, {
              tipoRicerca: "nome prodotto",
              valoreRicerca: shortName,
            });
            return;
          }
          setProductFunction(data[0] || prodVuoto);
        })
      }

    return(
            <div>
            <form onSubmit={handleSubmit} class={inputStyle}>
                 {/* <div class="measure"> */}
                 {showLabels && <label for="name" class="b db mr2">Nome prodotto</label>}
                    <input 
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        id="name"
                        name='name'
                        list='listaNames'
                        className="input-reset ba bordoColScrittaDef-20 pa2 db w-100"
                        type="text"
                        aria-describedby="name-desc"
                      />
                      {input.length > 3 && <datalist id="listaNames">
                            {listaNomiProdottoFiltrata.map((b,i) => {
                                return <option key={i} value={b} />})};
                        </datalist>}
                    {showDescs && <small id="name-desc" class="f6 black-20 db mb2">Short name esatto</small>}
                    {orientamento === "tasto" && <button className={stilePulsanti.classiTastoSblocco} onClick={handleSubmit}><span class="material-icons md-13 gray ma1">search</span></button>}
                {/* </div> */}
            </form>
            </div>
    );

}

export default InputNomeProd;


